import {gringortenRaw} from "../gringorten.js";
import quincuncial from "./index.js";

export default function() {
  return quincuncial(gringortenRaw)
      .scale(176.423);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-geo-projection/src/quincuncial/gringorten.js
// module id = 750
// module chunks = 0